<template>
  <div v-if="filters && filters.length > 0" class="input_filter_container is-align-items-center is-flex">
      <div v-for="filter in filters" :key="filter.designator" class="file_checkbox">
        <label class="is-checkbox is-flex">
          <div v-if="!filter.first" class="mx-3">|</div>
          <div v-if="!filter.rtl">{{ filter.title }}</div>
          <input type="checkbox" v-model="data[filter.designator]" @change="() => onChange(filter)" />
          <div class="is-checkbox__checkmark mx-3"></div>
          <div v-if="filter.rtl">{{ filter.title }}</div>
        </label>
      </div>
  </div>
</template>
<script>
export default {
  name: 'filters-checkbox',
  props: ['filters'],
  data () {
    return {
      data: {}
    }
  },
  created () {
    this.filters.forEach(filter => {
      this.$set(this.data, filter.designator, !!this.$route.query[filter.designator])
    })
  },
  methods: {
    onChange (filter) {
      this.data[filter.designator] = !this.data[filter.designator]
      const toggler = this.data[filter.designator] ? undefined : 'TRUE'
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, [filter.designator]: toggler, ...filter.custom_addition_to_query } })
    }
  }
}
</script>
<style scoped>
.input_filter_container {
  margin: 15px 0 15px 30px;
}
.input_horizontal_space {
  margin-right: 10px;
}
.is-checkbox {
  height: 25px;
  line-height: 25px;
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.is-checkbox input {
  display: none;
}
.is-checkbox__checkmark {
  height: 25px;
  width: 25px;
  background-color: #eee;
}
.is-checkbox:hover input ~ .is-checkbox__checkmark {
  background-color: #ccc;
}
.is-checkbox input:checked ~ .is-checkbox__checkmark {
  background-color: #2196f3;
}
.is-checkbox__checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.is-checkbox input:checked ~ .is-checkbox__checkmark:after {
  display: block;
}
.is-checkbox .is-checkbox__checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
